import { useCallback } from 'react';

const useLoadExecutions = () => {
    const loadExecutions = useCallback((executions) => {
        if (executions?.length) {
            const scriptElm = document.createElement('script');
            executions.forEach((execution) => {
                scriptElm.appendChild(document.createTextNode(execution.pixel));
            });
            document.body.appendChild(scriptElm);
            document.body.removeChild(scriptElm);
        }
    }, []);
    return { loadExecutions };
};

export { useLoadExecutions as default };
//# sourceMappingURL=useLoadExecutions.js.map
